import { useQueryClient } from "@tanstack/react-query"
import { useCallback } from "react"
import { useAuthStore, useStudentOnboardingStore } from "../store"
import { useGroupStore } from "../store/groups/useGroupStore"
import { useIntakeStore } from "../store/intake/useIntakeStore"
import { useExamStore } from "../store/exams/useExamStore"

export function useLogout() {
  const queryClient = useQueryClient()
  const { logout: clearAuth } = useAuthStore()
  const { clearGroup } = useGroupStore()
  const { clearIntake } = useIntakeStore()
  const { clearInfo } = useStudentOnboardingStore()
  const { clearExam } = useExamStore()

  const logout = useCallback(() => {
    clearAuth()
    clearGroup()
    clearIntake()
    clearInfo()
    clearExam()

    Promise.resolve().then(() => queryClient.clear())
  }, [queryClient, clearAuth, clearGroup, clearIntake, clearInfo, clearExam])

  return { logout }
}
